import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ChangePassword } from 'app/auth/components';
import { selectCallEndedStatus } from 'app/settings/selectors';
import { changeEndedStatus } from 'app/settings/slices';

const mapStateToProps = ({ settings }) => ({
  endedStatus: selectCallEndedStatus({ settings }),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    changeEndedStatus,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
